/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BsShopIntegrationData } from './BsShopIntegrationData';
import {
    BsShopIntegrationDataFromJSON,
    BsShopIntegrationDataFromJSONTyped,
    BsShopIntegrationDataToJSON,
    BsShopIntegrationDataToJSONTyped,
} from './BsShopIntegrationData';
import type { MetaIntegrationAdAccountData } from './MetaIntegrationAdAccountData';
import {
    MetaIntegrationAdAccountDataFromJSON,
    MetaIntegrationAdAccountDataFromJSONTyped,
    MetaIntegrationAdAccountDataToJSON,
    MetaIntegrationAdAccountDataToJSONTyped,
} from './MetaIntegrationAdAccountData';
import type { ShoptetIntegrationData } from './ShoptetIntegrationData';
import {
    ShoptetIntegrationDataFromJSON,
    ShoptetIntegrationDataFromJSONTyped,
    ShoptetIntegrationDataToJSON,
    ShoptetIntegrationDataToJSONTyped,
} from './ShoptetIntegrationData';
import type { GoogleIntegrationCustomerClientData } from './GoogleIntegrationCustomerClientData';
import {
    GoogleIntegrationCustomerClientDataFromJSON,
    GoogleIntegrationCustomerClientDataFromJSONTyped,
    GoogleIntegrationCustomerClientDataToJSON,
    GoogleIntegrationCustomerClientDataToJSONTyped,
} from './GoogleIntegrationCustomerClientData';
import type { MySQLLeadIntegrationData } from './MySQLLeadIntegrationData';
import {
    MySQLLeadIntegrationDataFromJSON,
    MySQLLeadIntegrationDataFromJSONTyped,
    MySQLLeadIntegrationDataToJSON,
    MySQLLeadIntegrationDataToJSONTyped,
} from './MySQLLeadIntegrationData';
import type { HeurekaIntegrationData } from './HeurekaIntegrationData';
import {
    HeurekaIntegrationDataFromJSON,
    HeurekaIntegrationDataFromJSONTyped,
    HeurekaIntegrationDataToJSON,
    HeurekaIntegrationDataToJSONTyped,
} from './HeurekaIntegrationData';
import type { MetaIntegrationData } from './MetaIntegrationData';
import {
    MetaIntegrationDataFromJSON,
    MetaIntegrationDataFromJSONTyped,
    MetaIntegrationDataToJSON,
    MetaIntegrationDataToJSONTyped,
} from './MetaIntegrationData';
import type { MicrosoftIntegrationData } from './MicrosoftIntegrationData';
import {
    MicrosoftIntegrationDataFromJSON,
    MicrosoftIntegrationDataFromJSONTyped,
    MicrosoftIntegrationDataToJSON,
    MicrosoftIntegrationDataToJSONTyped,
} from './MicrosoftIntegrationData';
import type { GoogleIntegrationData } from './GoogleIntegrationData';
import {
    GoogleIntegrationDataFromJSON,
    GoogleIntegrationDataFromJSONTyped,
    GoogleIntegrationDataToJSON,
    GoogleIntegrationDataToJSONTyped,
} from './GoogleIntegrationData';
import type { MicrosoftIntegrationCustomerData } from './MicrosoftIntegrationCustomerData';
import {
    MicrosoftIntegrationCustomerDataFromJSON,
    MicrosoftIntegrationCustomerDataFromJSONTyped,
    MicrosoftIntegrationCustomerDataToJSON,
    MicrosoftIntegrationCustomerDataToJSONTyped,
} from './MicrosoftIntegrationCustomerData';
import type { UpgatesIntegrationData } from './UpgatesIntegrationData';
import {
    UpgatesIntegrationDataFromJSON,
    UpgatesIntegrationDataFromJSONTyped,
    UpgatesIntegrationDataToJSON,
    UpgatesIntegrationDataToJSONTyped,
} from './UpgatesIntegrationData';
import type { SklikIntegrationData } from './SklikIntegrationData';
import {
    SklikIntegrationDataFromJSON,
    SklikIntegrationDataFromJSONTyped,
    SklikIntegrationDataToJSON,
    SklikIntegrationDataToJSONTyped,
} from './SklikIntegrationData';

/**
 * 
 * @export
 * @interface ListProjectIntegrations200ResponseInner
 */
export interface ListProjectIntegrations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    project?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    accessToken?: string;
    /**
     * 
     * @type {Array<MetaIntegrationAdAccountData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    metaIntegrationAdAccounts?: Array<MetaIntegrationAdAccountData>;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    refreshToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    scope?: string;
    /**
     * 
     * @type {Array<GoogleIntegrationCustomerClientData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    googleIntegrationCustomerClients?: Array<GoogleIntegrationCustomerClientData>;
    /**
     * 
     * @type {Array<MicrosoftIntegrationCustomerData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    microsoftIntegrationCustomers?: Array<MicrosoftIntegrationCustomerData>;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    apiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    databaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    tableName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    customWhere?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    categoryColumns?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnVerified?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmMedium?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmContent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnClickId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmCampaign?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmCampaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmAdSetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmAdSetAdId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    knownStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    refundedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    skippedEmailAddressList?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    knownCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    b2cCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    b2bCentres?: Array<string>;
}

/**
 * Check if a given object implements the ListProjectIntegrations200ResponseInner interface.
 */
export function instanceOfListProjectIntegrations200ResponseInner(value: object): value is ListProjectIntegrations200ResponseInner {
    return true;
}

export function ListProjectIntegrations200ResponseInnerFromJSON(json: any): ListProjectIntegrations200ResponseInner {
    return ListProjectIntegrations200ResponseInnerFromJSONTyped(json, false);
}

export function ListProjectIntegrations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProjectIntegrations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
        'project': json['project'] == null ? undefined : json['project'],
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
        'metaIntegrationAdAccounts': json['metaIntegrationAdAccounts'] == null ? undefined : ((json['metaIntegrationAdAccounts'] as Array<any>).map(MetaIntegrationAdAccountDataFromJSON)),
        'refreshToken': json['refreshToken'] == null ? undefined : json['refreshToken'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'googleIntegrationCustomerClients': json['googleIntegrationCustomerClients'] == null ? undefined : ((json['googleIntegrationCustomerClients'] as Array<any>).map(GoogleIntegrationCustomerClientDataFromJSON)),
        'microsoftIntegrationCustomers': json['microsoftIntegrationCustomers'] == null ? undefined : ((json['microsoftIntegrationCustomers'] as Array<any>).map(MicrosoftIntegrationCustomerDataFromJSON)),
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customWhere': json['customWhere'] == null ? undefined : json['customWhere'],
        'categoryColumns': json['categoryColumns'] == null ? undefined : json['categoryColumns'],
        'columnDate': json['columnDate'] == null ? undefined : json['columnDate'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'columnCountry': json['columnCountry'] == null ? undefined : json['columnCountry'],
        'columnVerified': json['columnVerified'] == null ? undefined : json['columnVerified'],
        'columnUtmSource': json['columnUtmSource'] == null ? undefined : json['columnUtmSource'],
        'columnUtmMedium': json['columnUtmMedium'] == null ? undefined : json['columnUtmMedium'],
        'columnUtmContent': json['columnUtmContent'] == null ? undefined : json['columnUtmContent'],
        'columnClickId': json['columnClickId'] == null ? undefined : json['columnClickId'],
        'columnUtmCampaign': json['columnUtmCampaign'] == null ? undefined : json['columnUtmCampaign'],
        'columnUtmCampaignId': json['columnUtmCampaignId'] == null ? undefined : json['columnUtmCampaignId'],
        'columnUtmAdSetId': json['columnUtmAdSetId'] == null ? undefined : json['columnUtmAdSetId'],
        'columnUtmAdSetAdId': json['columnUtmAdSetAdId'] == null ? undefined : json['columnUtmAdSetAdId'],
        'knownStatuses': json['knownStatuses'] == null ? undefined : json['knownStatuses'],
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
        'skippedEmailAddressList': json['skippedEmailAddressList'] == null ? undefined : json['skippedEmailAddressList'],
        'knownCentres': json['knownCentres'] == null ? undefined : json['knownCentres'],
        'b2cCentres': json['b2cCentres'] == null ? undefined : json['b2cCentres'],
        'b2bCentres': json['b2bCentres'] == null ? undefined : json['b2bCentres'],
    };
}

export function ListProjectIntegrations200ResponseInnerToJSON(json: any): ListProjectIntegrations200ResponseInner {
    return ListProjectIntegrations200ResponseInnerToJSONTyped(json, false);
}

export function ListProjectIntegrations200ResponseInnerToJSONTyped(value?: ListProjectIntegrations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'project': value['project'],
        'accessToken': value['accessToken'],
        'metaIntegrationAdAccounts': value['metaIntegrationAdAccounts'] == null ? undefined : ((value['metaIntegrationAdAccounts'] as Array<any>).map(MetaIntegrationAdAccountDataToJSON)),
        'refreshToken': value['refreshToken'],
        'scope': value['scope'],
        'googleIntegrationCustomerClients': value['googleIntegrationCustomerClients'] == null ? undefined : ((value['googleIntegrationCustomerClients'] as Array<any>).map(GoogleIntegrationCustomerClientDataToJSON)),
        'microsoftIntegrationCustomers': value['microsoftIntegrationCustomers'] == null ? undefined : ((value['microsoftIntegrationCustomers'] as Array<any>).map(MicrosoftIntegrationCustomerDataToJSON)),
        'apiKey': value['apiKey'],
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'password': value['password'],
        'databaseName': value['databaseName'],
        'tableName': value['tableName'],
        'domain': value['domain'],
        'customWhere': value['customWhere'],
        'categoryColumns': value['categoryColumns'],
        'columnDate': value['columnDate'],
        'timeZone': value['timeZone'],
        'columnCountry': value['columnCountry'],
        'columnVerified': value['columnVerified'],
        'columnUtmSource': value['columnUtmSource'],
        'columnUtmMedium': value['columnUtmMedium'],
        'columnUtmContent': value['columnUtmContent'],
        'columnClickId': value['columnClickId'],
        'columnUtmCampaign': value['columnUtmCampaign'],
        'columnUtmCampaignId': value['columnUtmCampaignId'],
        'columnUtmAdSetId': value['columnUtmAdSetId'],
        'columnUtmAdSetAdId': value['columnUtmAdSetAdId'],
        'knownStatuses': value['knownStatuses'],
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
        'skippedEmailAddressList': value['skippedEmailAddressList'],
        'knownCentres': value['knownCentres'],
        'b2cCentres': value['b2cCentres'],
        'b2bCentres': value['b2bCentres'],
    };
}

